import { render, staticRenderFns } from "./WebLinkTrafalgarRiver.vue?vue&type=template&id=4887538c&scoped=true&"
import script from "./WebLinkTrafalgarRiver.vue?vue&type=script&lang=js&"
export * from "./WebLinkTrafalgarRiver.vue?vue&type=script&lang=js&"
import style0 from "./WebLinkTrafalgarRiver.vue?vue&type=style&index=0&id=4887538c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4887538c",
  null
  
)

export default component.exports